export default "__VITE_ASSET__f5f5aa8d__"